import { CheckIcon, Cross1Icon, UpdateIcon } from "@radix-ui/react-icons";
import _ from "lodash";
import moment from "moment";
import "moment/locale/cs";
import { useSelector } from "react-redux";
import { useGetRevisions } from "src/lib/sync";
import { syncPropertiesTranslations } from "src/lib/syncPropertiesTranslations";
import GoogleLogin from "./GoogleLogin";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { AlcDrawer, DrawerTitle } from "./ui/drawer";

export default function SyncDrawer({
  children,
}: {
  children: React.ReactNode;
}) {
  const syncState = useSelector((state: any) => state.sync);

  const currentRevisions = useGetRevisions();

  const getSyncMostRecentSynced = (property: string) => {
    const currentRevision = currentRevisions[property];
    if (!_.isNumber(currentRevision)) return true;
    const lastSyncedRevision = syncState[property + "Revision"];
    if (!_.isNumber(lastSyncedRevision)) return false;
    return currentRevision === lastSyncedRevision;
  };

  return (
    <AlcDrawer
      asChild
      trigger={children}
      header={<DrawerTitle>Ukládání na cloud</DrawerTitle>}
    >
      <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
        {Object.keys(syncPropertiesTranslations).map((key) => (
          <Card key={key} style={{ flex: "1 0 0" }}>
            <CardHeader className="p-4 pb-2">
              <CardTitle
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1ch",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "1.25rem",
                    aspectRatio: "1/1",
                    borderRadius: "50%",
                    flexShrink: 0,
                    backgroundColor: syncState.syncing.includes(key)
                      ? "var(--pending)"
                      : getSyncMostRecentSynced(key)
                      ? "var(--success)"
                      : "var(--error)",
                  }}
                >
                  {syncState.syncing.includes(key) ? (
                    <UpdateIcon />
                  ) : getSyncMostRecentSynced(key) ? (
                    <CheckIcon />
                  ) : (
                    <Cross1Icon />
                  )}
                </div>
                {syncPropertiesTranslations[key]}
              </CardTitle>
            </CardHeader>
            <CardContent
              className="p-4 pt-0"
              style={{
                paddingLeft: "calc(2.25rem + 1ch)",
                color: "hsl(var(--muted-foreground))",
              }}
            >
              {syncState[key]
                ? moment
                    .duration(
                      new Date(syncState[key]).getTime() - new Date().getTime()
                    )
                    .locale("cs")
                    .humanize(true)
                : "nikdy"}
            </CardContent>
          </Card>
        ))}
      </div>
      <h3 className="pt-4 font-medium">Propojení s Google účtem</h3>
      <div
        style={{
          color: "hsl(var(--muted-foreground))",
          margin: 0,
          fontSize: "0.8rem",
          paddingBottom: "0.5rem",
        }}
      >
        Propojení s Google účtem vám umožní obnovit data po reinstalaci aplikace
      </div>
      <GoogleLogin />
    </AlcDrawer>
  );
}
